var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrainer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    enableBackground: "new 0 0 200 200",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1_Kopie"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 100,
    y1: 102,
    x2: 100,
    y2: 2,
    gradientTransform: "matrix(1 0 0 -1 0 202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#95C120",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#95C120"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M173,100c0,40.3-32.7,73-73,73s-73-32.7-73-73H0v100h200V100H173z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ausbilder_x2F_-in_Form"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M65.6,183.2l0.4-2.1l-2.3-1l-1.2,1.8l-2.1-0.9l6.3-7.9l2.5,1.1l-1.5,9.9L65.6,183.2z M64.8,178.8l1.6,0.7 l0.9-4.3L64.8,178.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M74.3,186.3l-1.8-0.6l0.2-0.9c-0.7,0.6-1.4,0.7-2.2,0.5c-0.6-0.2-1-0.5-1.1-1c-0.2-0.5-0.2-1.1,0-1.7 l1.7-5.2l2,0.7l-1.7,5c-0.2,0.5-0.1,0.8,0.3,0.9c0.3,0.1,0.7,0,1.2-0.5l1.7-5l2,0.7L74.3,186.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M81.7,180.5c0.4,0.3,0.7,0.6,0.9,0.9l-1,1c-0.5-0.5-0.9-0.8-1.4-0.9c-0.3-0.1-0.5-0.1-0.6,0 c-0.2,0.1-0.3,0.2-0.3,0.4c0,0.1,0,0.3,0,0.4c0,0.1,0.2,0.2,0.3,0.4c0.2,0.1,0.4,0.3,0.8,0.6c0.6,0.4,1,0.8,1.3,1.2 c0.2,0.4,0.3,0.9,0.1,1.5c-0.2,0.7-0.6,1.2-1.3,1.5c-0.7,0.3-1.4,0.3-2.3,0.1c-0.6-0.1-1-0.4-1.5-0.7c-0.4-0.3-0.8-0.7-1-1.1 L77,185c0.5,0.6,1,1,1.5,1.1c0.3,0.1,0.5,0.1,0.7,0s0.3-0.2,0.4-0.5c0-0.2,0-0.3,0-0.4c0-0.1-0.1-0.3-0.3-0.4 c-0.2-0.1-0.4-0.3-0.8-0.6c-0.6-0.4-1-0.8-1.2-1.2c-0.2-0.4-0.3-0.9-0.1-1.4c0.1-0.4,0.3-0.8,0.6-1c0.3-0.3,0.7-0.5,1.1-0.6 c0.5-0.1,1-0.1,1.5,0.1C80.8,180.1,81.3,180.3,81.7,180.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M89.4,182.7c0.3,0.7,0.4,1.7,0.2,3c-0.1,0.8-0.3,1.4-0.6,2c-0.3,0.6-0.7,1-1.1,1.2 c-0.4,0.3-0.9,0.3-1.5,0.3c-0.4-0.1-0.7-0.2-0.9-0.4c-0.3-0.2-0.5-0.5-0.7-0.8l-0.2,0.7l-1.9-0.3l1.6-10.3l2.2,0.1l-0.6,3.9 c0.2-0.3,0.5-0.5,0.9-0.6s0.7-0.2,1.1-0.1C88.6,181.6,89.1,182,89.4,182.7z M86.8,187.2c0.2-0.3,0.4-0.9,0.6-1.8 c0.1-0.9,0.2-1.5,0-1.9c-0.1-0.4-0.3-0.6-0.6-0.6c-0.2,0-0.4,0-0.6,0.1s-0.4,0.3-0.6,0.5l-0.5,3.2c0.2,0.5,0.5,0.8,0.9,0.8 C86.3,187.6,86.6,187.5,86.8,187.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M93.4,182.3l-0.7,7.4l-2.1-0.2l0.7-7.4L93.4,182.3z M93.5,178.8c0.2,0.3,0.3,0.6,0.3,0.9 c0,0.4-0.2,0.6-0.4,0.8c-0.3,0.2-0.6,0.3-0.9,0.3s-0.6-0.2-0.9-0.4c-0.2-0.3-0.3-0.6-0.3-0.9c0-0.3,0.2-0.6,0.4-0.8 c0.3-0.2,0.6-0.3,0.9-0.3S93.3,178.5,93.5,178.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M94.9,189.6c-0.3-0.4-0.5-0.9-0.4-1.5l0.4-8.6l2.2-0.1l-0.4,8.7c0,0.3,0.1,0.4,0.3,0.4c0.1,0,0.2,0,0.3,0 l0.3,1.5c-0.4,0.2-0.8,0.2-1.3,0.2C95.7,190.1,95.3,189.9,94.9,189.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M104.5,179.5l0.2,10.4l-1.9,0l-0.1-0.8c-0.5,0.7-1.1,1.1-1.9,1.1c-0.8,0-1.5-0.3-1.9-1 c-0.5-0.7-0.7-1.7-0.7-2.9c0-0.8,0.1-1.5,0.3-2.1c0.2-0.6,0.5-1.1,0.9-1.4s0.9-0.5,1.4-0.5c0.6,0,1.1,0.2,1.6,0.7l-0.1-3.6 L104.5,179.5z M102.1,188.4c0.2-0.1,0.3-0.3,0.5-0.6l-0.1-3.4c-0.2-0.2-0.3-0.4-0.4-0.4c-0.1-0.1-0.3-0.1-0.5-0.1 c-0.7,0-1.1,0.8-1.1,2.4c0,0.9,0.1,1.5,0.3,1.9c0.2,0.3,0.4,0.5,0.8,0.5C101.7,188.6,101.9,188.6,102.1,188.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M112.4,186.1l-4.1,0.4c0.1,0.6,0.3,1.1,0.6,1.3c0.3,0.2,0.6,0.3,1,0.3c0.3,0,0.5-0.1,0.8-0.2 c0.2-0.1,0.5-0.3,0.8-0.6l1,1.1c-0.7,0.8-1.5,1.2-2.6,1.3c-1.1,0.1-2-0.1-2.7-0.8c-0.7-0.6-1-1.6-1.2-2.8c-0.1-1.2,0.1-2.2,0.5-3 c0.5-0.8,1.2-1.2,2.2-1.3c1-0.1,1.8,0.1,2.4,0.7s1,1.5,1.1,2.7C112.3,185.6,112.4,185.9,112.4,186.1z M110.1,184.9 c-0.1-0.6-0.2-1-0.4-1.3c-0.2-0.3-0.5-0.4-0.8-0.4c-0.3,0-0.6,0.2-0.7,0.5c-0.1,0.3-0.2,0.8-0.2,1.5L110.1,184.9L110.1,184.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M117.2,180.7l0,2.1c-0.2,0-0.4,0-0.6,0c-0.4,0.1-0.6,0.3-0.8,0.6c-0.2,0.3-0.2,0.8-0.2,1.4l0.7,3.7 l-2.1,0.4l-1.3-7.3l1.9-0.3l0.4,1.3c0.1-0.5,0.2-0.9,0.5-1.2c0.2-0.3,0.6-0.5,1-0.6C116.8,180.7,117,180.7,117.2,180.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M119.1,176.2l1.9,0l0,12.9l-1.9,0L119.1,176.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M124.3,183l-0.5-1.6l3.9-1.2l0.5,1.6L124.3,183z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M128.8,173.6c0.3,0.1,0.5,0.4,0.6,0.7c0.1,0.3,0.1,0.6,0,1c-0.1,0.3-0.4,0.5-0.7,0.6c-0.3,0.1-0.7,0.1-1,0 s-0.5-0.4-0.6-0.7c-0.1-0.3-0.1-0.6,0-0.9c0.1-0.3,0.4-0.5,0.7-0.6C128.2,173.5,128.5,173.5,128.8,173.6z M130.2,176.9l2.6,7 l-2,0.8l-2.6-7L130.2,176.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M136.6,174.5c0.5,0.2,0.8,0.6,1.1,1.2l2.3,5l-2,0.9l-2.2-4.7c-0.1-0.3-0.3-0.5-0.4-0.5 c-0.1-0.1-0.3-0.1-0.4,0c-0.2,0.1-0.3,0.2-0.4,0.4c-0.1,0.2-0.2,0.5-0.2,0.8l2.1,4.7l-2,0.9l-3.1-6.8l1.7-0.8l0.5,0.7 c0.1-0.5,0.2-0.8,0.5-1.1c0.2-0.3,0.5-0.5,0.9-0.7C135.6,174.3,136.1,174.3,136.6,174.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainer);
export default __webpack_public_path__ + "static/media/trainer.5a72ecbfefd28b361b5ced0474f61e12.svg";
export { ForwardRef as ReactComponent };